<div class="spinner-overlay" *ngIf="isLoading$ | async">
  <p-progressSpinner></p-progressSpinner>
</div>
